<template>
    <div>
        <a id="btn-prev-page"
           class="nav_btn hover-effect"
           href="#"
           @click.prevent="goPrevPage"
           :title="i18n.t('tooltip_prev')"
           v-show="!pageState.isFirstPage"
        >
            <img class="full-size" src="~images/btn_prev_page.png">
        </a>
        <a id="btn-next-page"
           class="nav_btn hover-effect"
           href="#"
           @click.prevent="goNextPage"
           :title="i18n.t('tooltip_next')"
           v-show="!pageState.isLastPage"
        >
            <img class="full-size" src="~images/btn_next_page.png">
        </a>
    </div>
</template>

<script>

   import {usePaging}  from "@/modules/reader/book/paging";
   import {inject}  from "vue"

    export default {

        setup(props, context) {
            const { pageState, goNextPage, goPrevPage} = usePaging();
            const i18n = inject('i18n');

            return {
                i18n,
                pageState,
                goNextPage,
                goPrevPage
            }
        }
    }
</script>

<style scoped lang="scss">

    $margin:25px;

    .nav_btn {
        position:fixed;
        top:50%;
        margin-top:-35px;
        width:70px;
        height:70px;
    }

    #btn-prev-page {
        left:$margin;
    }

    #btn-next-page {
        right:$margin;
    }
</style>